import type { ReactNode } from "react";

export function MetricCard({
  label,
  value,
  note,
  tone = "neutral",
  marker
}: {
  label: string;
  value: ReactNode;
  note?: ReactNode;
  tone?: "neutral" | "good" | "warn" | "bad";
  marker?: string;
}) {
  return (
    <article className={`metric-card metric-card--${tone}`}>
      <div className="metric-card__head">
        <span>{label}</span>
        {marker ? <span className="metric-card__marker">{marker}</span> : null}
      </div>
      <div className="metric-card__value">{value}</div>
      {note ? <div className="metric-card__note">{note}</div> : null}
    </article>
  );
}
